import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface Props{
  setDescription : React.Dispatch<React.SetStateAction<String | null>>
}

const TextEditor: React.FC<Props> = ({ setDescription }) => {
    // const [ content,setContent ] = useState<string>("")
    const quillRef = useRef<ReactQuill>(null);

    const handleGetContent = () => {
      if (quillRef.current) {
        const content = quillRef.current.getEditor().root.innerHTML;
        setDescription(content);
      }
    };

  // const handleFocusEditor = () => {
  //   if (quillRef.current) {
  //     quillRef.current.focus();
  //   }
  // };

  return (
    <>
      <ReactQuill
        theme="snow"
        ref={quillRef}
        onChange={handleGetContent}
        placeholder="Write something..."
      />
      {/* <button onClick={handleGetContent}>Get Content</button> */}
      {/* <button onClick={handleFocusEditor}>Focus Editor</button> */}
      {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}
    </>
  );
};

export default TextEditor;
